import { MonitorOutlined } from '@ant-design/icons'

const Monitor = ({ ...props }) => {
  return <MonitorOutlined className="text-[20px] cursor-pointer ml-0" {...props} />
}

export default Monitor
